import { useEffect, useState } from 'react';
import { ContractService } from '../../../services/contract/contractService';
import { State } from '../../../type/entities/state-type';

/*-------------------------------------------------------------------------------------------------
* EN: Hook to manage contract payment methods fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de métodos de pago de contrato.
-------------------------------------------------------------------------------------------------*/

const usePaymentMethods = () => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchPaymentMethods = async () => {
        setIsLoading(true);
        try {
            const service = new ContractService();
            const response = await service.getPaymentMethods();
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: State) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching payment methods:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentMethods();
    }, []);

    const getPaymentMethodsList = (entity?: string | null, notShowStatusID?: string | null) => {
        if (entity) return data.filter((state: any) => state.entity === entity);
        if (notShowStatusID) return data.filter((state: any) => state.value !== notShowStatusID);
        return data;
    };

    return { fetchPaymentMethods, getPaymentMethodsList, isLoadingPaymentMethods: isLoading };
}

export default usePaymentMethods;